/** One create attempt per Add dialog submission, including retries after an uncertain failure. */
export function createAddSubmissionGate(
	createKey: () => string = () => crypto.randomUUID(),
) {
	let pending = false;
	let attempt: { fingerprint: string; key: string } | null = null;

	return {
		begin(payload: unknown): string | null {
			if (pending) return null;
			const fingerprint = JSON.stringify(payload);
			if (!attempt || attempt.fingerprint !== fingerprint) {
				attempt = { fingerprint, key: createKey() };
			}
			pending = true;
			return attempt.key;
		},
		finish(succeeded: boolean): void {
			pending = false;
			if (succeeded) attempt = null;
		},
	};
}
